import { render, staticRenderFns } from "./DistanceModalCreateLinkedStarts.vue?vue&type=template&id=4892b20e&scoped=true&"
import script from "./DistanceModalCreateLinkedStarts.vue?vue&type=script&lang=js&"
export * from "./DistanceModalCreateLinkedStarts.vue?vue&type=script&lang=js&"
import style0 from "./DistanceModalCreateLinkedStarts.vue?vue&type=style&index=0&id=4892b20e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4892b20e",
  null
  
)

export default component.exports